import { Configurable } from "@crystal/config";
const US = {
  en_US: Configurable.props({
    minLegalAge: 13
  })
};
export {
  US
};
//# sourceMappingURL=US.js.map
